import { createAction, props } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { GlossarioOutputDto } from "src/app/domain/DTOs/output/glossario.output.dto";

const actionName = "[ ObterGlossario ] Obter glossario";

export const obterGlossario = createAction(
  actionName
);

export const obterGlossarioSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<GlossarioOutputDto[]> }>()
);

export const obterGlossarioFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<GlossarioOutputDto[]> }>()
);

export const obterGlossarioFinish = createAction(
  `${actionName} - Concluir`
);
